import { render, staticRenderFns } from "./ModalEditarContaEmail.vue?vue&type=template&id=5cf272cd&scoped=true&"
import script from "./ModalEditarContaEmail.vue?vue&type=script&lang=js&"
export * from "./ModalEditarContaEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarContaEmail.vue?vue&type=style&index=0&id=5cf272cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf272cd",
  null
  
)

export default component.exports